import React, { useState, useRef } from "react";
import styled from "styled-components";
import ActionBar from "../../common/ActionBar";
import _ from "lodash";
import labels from "../../../helpers/labels.json";
import FileTracking from "./component/FileUpload";
import PropTypes from "prop-types";
import { makeStyles, AppBar, Tabs, Tab } from "@material-ui/core";
import { Formik } from "formik";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import ArbitratorMeeting from "./component/ArbitratorMeeting";
import ArbitratorRecordings from "./component/ArbitratorRecordings";
import useUser from "../../../hooks/useUser";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
`;

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    boxShadow: "none",
    background: "transparent",
    fontFamily: theme.fonts.primaryFontBold,
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      [themes.breakpoints.up(640)]: {
        justifyContent: "flex-start",
      },
    },
  },

  label: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    [themes.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },
}));

const RoutingTracker = () => {
  const classes = useStyles();
  const breadcrumbs = [_.startCase(labels.notice_tracking)];
  const [modal, setModal] = useState({ state: false });
  const MTRef = useRef();
  const [value, setValue] = useState(0);
  const { userObject, trackingToken, setTrackingToken } = useUser();

  const actions = [
    {
      text: "Notice Tracking",
      props: {
        onClick: () => setModal({ state: true }),
      },
    },
  ];

  return (
    <React.Fragment>
      <ActionBar {...{ breadcrumbs, actions }} />
      <Container>
        <Formik
          initialValues={{
            trackingIds: [],
            trackingMetaData: "",
          }}
          enableReinitialize
          validateOnBlur
          validateOnChange
          onSubmit={""}
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            touched,
            setFieldValue,
            setFieldError,
            handleBlur,
            isValid,
            resetForm,
          }) => (
            <form>
              <div className="paymentHistory">
                <div className={classes.root}>
                  <AppBar className={classes.appBar} position="static">
                    <Tabs
                      value={value}
                      indicatorColor="primary"
                      onChange={(_, newValue) => setValue(newValue)}
                      aria-label="pending-action-tab"
                    >
                      <Tab
                        label={
                          <div className={classes.label}>Tracking Files</div>
                        }
                        {...a11yProps(0)}
                      />
                      <Tab
                        label={
                          <div className={classes.label}>Tracking Notice</div>
                        }
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </AppBar>

                  <TabPanel value={value} index={0}>
                    <ArbitratorMeeting
                      {...{ MTRef, setValue, setFieldValue, setTrackingToken }}
                      page={values.page}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <ArbitratorRecordings
                      {...{ MTRef, trackingToken }}
                      trackingIds={values?.trackingIds}
                      trackingMetaData={values?.trackingMetaData}
                    />
                  </TabPanel>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Container>
      {modal?.state && (
        <FileTracking {...{ modal, setModal, MTRef, userObject }} />
      )}
    </React.Fragment>
  );
};

export default RoutingTracker;

export const Container = styled.div`
  padding: 30px 20px;
  min-height: 100vh;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
`;

export const TimelineWrapper = styled.div`
  padding: 0 16px 16px;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 1000px;
    }
  }
`;

export const Timeline = styled.div`
  position: relative;
  padding-left: 0;

  &::before {
    content: "";
    position: absolute;
    left: 7px;
    top: 24px;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, #00838c, transparent);
  }
`;

export const TimelineEvent = styled.div`
  position: relative;
  margin-bottom: 24px;
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.isLast &&
    `
    &::before {
      content: "";
      position: absolute;
      left: 7px;
      top: 24px;
      bottom: 0;
      width: 2px;
      background: transparent;
    }
  `}
`;

export const TimelineDot = styled.div`
  position: absolute;
  left: 0;
  top: 2px;
  width: 16px;
  height: 16px;
  background: white;
  border: 3px solid #00838c;
  border-radius: 50%;
  transition: all 0.3s;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);

  ${TimelineEvent}:hover & {
    background: #00838c;
    box-shadow: 0 0 12px rgba(102, 126, 234, 0.4);
    transform: scale(1.3);
  }
`;

export const EventContent = styled.div`
  background: #f9f9fa;
  padding: 12px;
  border-radius: 8px;
  border-left: 2px solid #00838c;
  transition: all 0.2s;

  ${TimelineEvent}:hover & {
    background: #f0f2f5;
    border-left-color: #764ba2;
  }
`;

export const EventHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const EventLocation = styled.h4`
  margin: 0;
  font-size: 13px;
  flex: 1;
  font-weight: 700;
  color: #293461;
  font-family: openSans-SemiBold, sans-serif;
`;

export const EventTime = styled.p`
  margin: 0;
  font-size: 10px;
  color: #8294a5;
  white-space: nowrap;
  font-family: openSans-SemiBold, sans-serif;
`;

export const EventType = styled.p`
  margin: 0;
  font-size: 12px;
  color: #8294a5;
  font-family: openSans-SemiBold, sans-serif;
`;

export const AWBNumber = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #293461;
  word-break: break-all;
`;

export const LastUpdated = styled.div`
  font-size: 11px;
  color: #8294a5;
  margin-top: 4px;
  font-family: openSans-SemiBold, sans-serif;
`;

export const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
  font-family: openSans-SemiBold, sans-serif;
  background: ${(props) => props.colors.bg};
  color: ${(props) => props.colors.text};
  border: 1.5px solid ${(props) => props.colors.border};
`;

export const StatusIcon = styled.span`
  font-size: 13px;
`;

export const ExpandIcon = styled.div`
  font-size: 16px;
  color: #00838c;
  transition: transform 0.3s;
  flex-shrink: 0;

  ${(props) =>
    props.isExpanded &&
    `
    transform: rotate(180deg);
  `}
`;

export const ShipmentCard = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    border-color: #00838c;
  }

  ${(props) =>
    props.isExpanded &&
    `
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.15);
    border-color: #00838c;
  `}
`;

export const ShipmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
`;

export const formatDate = (timestamp) => {
  if (!timestamp) return "";

  // Input format: 14-11-2025 04:35 PM
  const [datePart, timePart, modifier] = timestamp.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);
  let [hours, minutes] = timePart.split(":").map(Number);

  // Convert 12-hour to 24-hour format
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  const date = new Date(year, month - 1, day, hours, minutes);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getStatusColor = (status) => {
  switch (status) {
    case "Delivered":
      return { bg: "#e8f5e9", text: "#2e7d32", border: "#4caf50" };
    case "In Transit":
      return { bg: "#e3f2fd", text: "#1565c0", border: "#2196f3" };
    case "Out for Delivery":
      return { bg: "#fff3e0", text: "#e65100", border: "#ff9800" };
    default:
      return { bg: "#f5f5f5", text: "#424242", border: "#9e9e9e" };
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "Delivered":
      return "";
    case "In Transit":
      return "";
    case "Out for Delivery":
      return "";
    default:
      return "•";
  }
};

